/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_UndoInputs */



/**
* | output |
* | --- |
* | "Undo" |
*
* @param {Knp_Terms_UndoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_undo = /** @type {((inputs?: Knp_Terms_UndoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_UndoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annuler")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rückgängig machen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Disfare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отменить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Deshacer")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("撤销")
	if (locale === "ja") return /** @type {LocalizedString} */ ("元に戻す")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्ववत")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desfazer")
	return /** @type {LocalizedString} */ ("Undo")
});